import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";

export const DashboardLayout = () => {
  const location = useLocation();
  
  // Pages that manage their own scrolling internally
  const immersivePages = ["/dashboard", "/messages", "/bookings"];
  const isImmersive = immersivePages.some(p => location.pathname.startsWith(p));

  return (
    <div className="h-[100dvh] flex flex-col w-full bg-background overflow-x-hidden">
      <Header />
      <main className={`flex-1 min-h-0 ${isImmersive ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"}`}>
        <Outlet />
      </main>
    </div>
  );
};
